import {EmployeeRef} from "../../api/Model";
import {Avatar, AvatarProps, Skeleton, Tooltip} from "@mui/material";
import {cachedImageStore} from "../../api/CachedImageStore";
import {Loading} from "../loading-data/LoadingData";

function EmployeeAvatarAsync({employee, avatarUrl, showNameTooltip = false, ...props}: {
    employee: EmployeeRef,
    avatarUrl: string | undefined,
    showNameTooltip?: boolean,
} & AvatarProps) {
    const isDeactivated = employee.deactivated;
    const content = (
        <Avatar
            src={avatarUrl}
            alt={employee.fullName}
            {...props}
            sx={{
                filter: isDeactivated ? 'grayscale(100%)' : undefined,
                opacity: isDeactivated ? 0.5 : undefined,
                ...props.sx,
            }}
        />
    );

    return showNameTooltip ? (
        <Tooltip title={`${employee.fullName}${isDeactivated ? ' (deactivated)' : ''}`}>
            {content}
        </Tooltip>
    ) : (
        content
    );
}

export default function EmployeeAvatar({employee, showNameTooltip = false, ...props}: {
    employee: EmployeeRef,
    showNameTooltip?: boolean,
} & AvatarProps) {
    const avatarUrl = cachedImageStore.get(`/employees/${employee.id}/avatar?size=80`);

    return (
        <Loading
            loading={
                <Skeleton variant="circular">
                    <Avatar {...props}/>
                </Skeleton>
            }
            value={avatarUrl}
        >{avatarUrl =>
            <EmployeeAvatarAsync
                employee={employee}
                avatarUrl={avatarUrl}
                showNameTooltip={showNameTooltip}
                {...props}
            />
        }</Loading>
    );
}